
import React from "react";
import { withRouter } from "react-router-dom";
import {
  Intent,
  ContextMenu,
} from "@blueprintjs/core";
import AccessAlert from 'components/layout/alerts/Access';
import Alert from 'components/layout/alerts/Classic'
import { getSessionPartialUrl, getSessionFullUrl } from "../../helper";
import Auth from "../../services/Auth";
import SessionTableCxtMenu from "./SessionTableCxtMenu";

import './SessionTable.css'
import TableLine from "./TableLine";
import TableHead from "./TableHead";
import Session from "../../services/Session";
import { downloadResultsToExcel } from "../../services/Exports";

class SessionTable extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      alertAccessOpen: false,
      alertAccessResultOpen: false,
      alertDeleteOpen: false,
      alertDeleteResultsOpen: false,
      clickedSession: {},
      copiedToClipboard: false
    };
  }

  buildContextMenu = s => {
    return (
      <SessionTableCxtMenu
        session={s}
        onPlay={this.openAlertPlay}
        onDelete={this.openAlertDelete}
        onDeleteResults={this.openAlertDeleteResults}
        onEdit={this.handleEdit}
        onResult={this.handleResult}
        onFeedback={this.handleFeedbacks}
        onChangeStatus={this.handleChangeStatus}
        onAccess={this.openAlertAccess}
        onAccessResult={this.openAlertAccessResult}
        onExportResults={this.handleExportResults}
        onMonitoring={this.handleMonitoring}
        onDuplicate={this.handleDuplicate}
        onAttributes={this.handleAttributes}
        onNewResults={this.handleNewResults}
      />
    );
  };

  showContextMenu = (e, session) => {
    e.preventDefault();
    ContextMenu.show(this.buildContextMenu(session), {
      left: e.clientX,
      top: e.clientY
    });
  };

  openAlertAccess = clickedSession => {
    this.setState({ clickedSession, alertAccessOpen: true });
  };

  openAlertAccessResult = clickedSession => {
    this.setState({ clickedSession, alertAccessResultOpen: true });
  };

  handleExportResults = async session => {
    const instances = await Session.getSessionInstances(session.id);
    downloadResultsToExcel(session, instances);
  }

  openAlertDelete = clickedSession => {
    this.setState({ clickedSession, alertDeleteOpen: true });
  };

  openAlertDeleteResults = clickedSession => {
    this.setState({ clickedSession, alertDeleteResultsOpen: true });
  };

  handleEdit = session => {
    const { id } = session;
    const { history } = this.props;

    return history.push(`edit/${id}`);
  };

  handleResult = session => {
    const { id } = session;
    const { history } = this.props;

    return history.push(`result/${id}`);
  };

  handleFeedbacks = session => {
    const { id } = session;
    const { history } = this.props;

    return history.push(`feedback/${id}`);
  };

  handleAttributes = session => {
    const { id } = session
    const { history } = this.props

    return history.push(`attributes/${id}`)
  }

  handleNewResults = session => {
    const { id } = session
    const { history } = this.props
    const uid = Auth.getUserId()

    return history.push(`resultats/${uid}/${id}`)
  }

  handleChangeStatus = (session, newStatus) =>
    this.props.onChangeSessionStatus(session.id, newStatus);

  handleAccessSession = () => {
    const { history } = this.props;
    const { clickedSession } = this.state;

    history.push(getSessionPartialUrl(clickedSession));
  };

  handleCopy = () => {
    this.setState({ copiedToClipboard: true });
    setTimeout(() => {
      this.setState({ copiedToClipboard: false });
    }, 2000);
  };

  handleMonitoring = session => {
    const { history } = this.props;
    const { metadata } = session;
    const { author, shortname } = metadata;

    return history.push(`monitor/${author}/${shortname}`);
  };

  handleDuplicate = session => this.props.onDuplicateSession(session);

  render() {
    let { sessions } = this.props;
    const { onDeleteSession, onDeleteResults } = this.props;
    const { clickedSession, alertAccessOpen, copiedToClipboard, alertAccessResultOpen, alertDeleteOpen, alertDeleteResultsOpen } = this.state;
    const { metadata } = clickedSession;
    const uid = Auth.getUserId()


    // Order sessions by created date
    sessions = sessions.sort((a, b) => {
      if (a.metadata.createdDate > b.metadata.createdDate) return -1;
      if (a.metadata.createdDate < b.metadata.createdDate) return 1;
      return 0;
    });

    return (
      <table className="bp3-html-table bp3-interactive full-width">
        <AccessAlert
          isOpen={alertAccessOpen}
          onClose={() => this.setState({ alertAccessOpen: false })}
          onConfirm={this.handleAccessSession}
          intent={Intent.PRIMARY}
          title={`Access session ${metadata && metadata.name}`}
          text={<p>
            Share the session by sending the link below to people you
            you want to invite <br />
            On your side, you can access the session by clicking on the
            "Access" button.
          </p>}
          // eslint-disable-next-line
          url={metadata && metadata.shortUrl || getSessionFullUrl(window.location, clickedSession)}
          handleCopy={this.handleCopy}
          copiedToClipboard={copiedToClipboard}
        />
        <AccessAlert
          isOpen={alertAccessResultOpen}
          onClose={() => this.setState({ alertAccessResultOpen: false })}
          onConfirm={() => this.handleNewResults(clickedSession)}
          intent={Intent.PRIMARY}
          title={`Access results of session ${metadata && metadata.name}`}
          text={<p>
            You can share results by sending the link right below, click on Copy url so you wan paste it wherever you like.
          </p>}
          url={`https://visual-sense-session.web.app/#/resultats/${uid}/${clickedSession.id}`}
          handleCopy={this.handleCopy}
          copiedToClipboard={copiedToClipboard}
        />
        <Alert
          isOpen={alertDeleteOpen}
          onClose={() => this.setState({ alertDeleteOpen: false })}
          onConfirm={() => onDeleteSession(clickedSession.id)}
          title='Delete this session'
          intent={Intent.DANGER}
          icon="trash"
          text={<p>
            Are you sure you want to delete this session{" "}
            <span className="bp3-text-muted">{metadata && metadata.name}</span>{" "}
            ?
          </p>}
          confirmButtonText="Delete"
        />
        <Alert
          isOpen={alertDeleteResultsOpen}
          onClose={() => this.setState({ alertDeleteResultsOpen: false })}
          onConfirm={() => onDeleteResults(clickedSession.id)}
          title='Delete results of this session'
          intent={Intent.DANGER}
          icon="trash"
          text={<p>
            Are you sure you want to delete the results of this session{" "}
            <span className="bp3-text-muted">{metadata && metadata.name}</span>{" "}
            ?
          </p>}
          confirmButtonText="Delete"
        />
        <TableHead />
        <tbody>
          {sessions.map((s, index) =>
            <TableLine
              key={index}
              onContextMenu={(e) => this.showContextMenu(e, s)}
              metadata={s.metadata}
              data={s.data}
              buildContextMenu={() => this.buildContextMenu(s)}
              session={s}
            />
          )}
        </tbody>
      </table>
    );
  }
}

export default withRouter(SessionTable);